export const ME_DATA = 'ME_DATA'